import { useState, useCallback, useRef, useEffect } from 'react';
import Select from '../Select/Select';

const defaultFormatOption = (item) => {
  return { value: item.id, label: item.title };
};

/**
 * @param resetKey — внешний фильтр справочника (например выбранная марка).
 *   Меняется — загруженный список больше не верен, забываем его.
 */
const SelectWithFetch = ({
  handleSetSelect,
  handleSetState,
  style,
  fetch,
  formatOption = defaultFormatOption,
  resetKey,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Флаг, а не options.length: справочник имеет право вернуть пустой список,
  // и по длине такой ответ навсегда оставался бы «ещё не загруженным» —
  // каждое открытие меню тянуло бы его заново.
  const loadedRef = useRef(false);
  const onFocus = useCallback(() => {
    if (isLoading || loadedRef.current) return;
    loadedRef.current = true;
    setIsLoading(true);
    fetch().then((res) => {
      const options = res.data.map(formatOption);
      setOptions(options);
    }).catch(() => {
      // Дать повторить попытку при следующем открытии: иначе одна сетевая
      // ошибка оставила бы поле пустым до перезагрузки страницы.
      loadedRef.current = false;
    }).finally(() => setIsLoading(false));
  }, [fetch, formatOption, isLoading]);

  useEffect(() => {
    loadedRef.current = false;
    setOptions([]);
  }, [resetKey]);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      onFocus={onFocus}
      style={style}
      isLoading={isLoading}
      {...props}
    />
  );
};

export default SelectWithFetch;
